import React, { Component } from 'react';
import { ConditionalPanel } from 'web-ui-components/lib/layout/content';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { PageHeading, SectionHeading } from 'web-ui-components/lib/typography/headings';
import { Form } from 'react-final-form';
import PropTypes from '../../types';
import { Content } from '../../infrastructure/content';
import Submit from '../../components/Submit';
import OldAddSignatoryDateOfBirth from './components/OldAddSignatoryDateOfBirth';
import Title from '../personDetailsSection/components/Title';
import TitleOther from '../personDetailsSection/components/TitleOther';
import FirstName from '../personDetailsSection/components/FirstName';
import LastName from '../personDetailsSection/components/LastName';
import OldAddSignatoryNationality from './components/OldAddSignatoryNationality';
import OldAddSignatoryCountryOfResidence from './components/OldAddSignatoryCountryOfResidence';
import { ButtonComponent } from '../../components/ButtonComponent';
import NationalityDropDown from './components/NationalityDropDown';
import CountryDropDown from './components/CountryDropDown';
import { OTHER_KEY } from '../../utils/constants';
import MiddleName from '../personDetailsSection/components/MiddleName';

class OldAddSignatoryPage extends Component {
  render() {
    const {
      saveOldAddSignatoryForm,
      getBusinessData,
      backClick,
      currentSignatoryIndex,
      fromAccordion = false
    } = this.props;
    return (
      <Form
        onSubmit={values => {
          saveOldAddSignatoryForm(values, currentSignatoryIndex);
        }}
        initialValues={getBusinessData}
        render={({ handleSubmit, values }) => (
          <form onSubmit={handleSubmit}>
            <Content>
              {({ oldAddSignatoryPageTitle = '', oldAccountSignatoryText = '' }) => (
                <StandardBody>
                  {fromAccordion ? (
                    <SectionHeading>{oldAddSignatoryPageTitle}</SectionHeading>
                  ) : (
                    <PageHeading>{oldAddSignatoryPageTitle}</PageHeading>
                  )}
                  <p>{oldAccountSignatoryText}</p>
                  <Title values={values} />
                  {values && values.title === OTHER_KEY && (
                    <ConditionalPanel isVisible>
                      <TitleOther />
                    </ConditionalPanel>
                  )}
                  <FirstName />
                  <MiddleName />
                  <LastName />
                  <OldAddSignatoryDateOfBirth />
                  <OldAddSignatoryNationality values={values} />
                  {values.nationality === OTHER_KEY && (
                    <NationalityDropDown removeCountries={['British']} values={values} />
                  )}
                  <OldAddSignatoryCountryOfResidence values={values} />
                  {values.country_of_residence === OTHER_KEY && (
                    <CountryDropDown removeCountries={['United Kingdom']} values={values} />
                  )}
                  {backClick ? (
                    <Submit hideExit />
                  ) : (
                    <ButtonComponent
                      title="Submit"
                      onClick={() => {
                        handleSubmit(values);
                      }}
                    ></ButtonComponent>
                  )}
                </StandardBody>
              )}
            </Content>
          </form>
        )}
      />
    );
  }
}
OldAddSignatoryPage.propTypes = {
  bankId: PropTypes.bankId.isRequired,
  saveOldAddSignatoryForm: PropTypes.func.isRequired
};

export default OldAddSignatoryPage;
